import { lazy } from 'react';
import { RouteType } from '@/Routes';

const UserShow = lazy(() => import('@/pages/users/[user_id]'));
const UserEdit = lazy(() => import('@/pages/users/edit'));
const UserSearchIndex = lazy(() => import('@/pages/users/search/index'));
const UserSearchType = lazy(() => import('@/pages/users/search/[type]'));
const UserSearchNew = lazy(() => import('@/pages/users/search/new'));

const ServerUser: RouteType[] = [
  {
    path: '/users/edit',
    component: UserEdit,
    title: 'プロフィール編集',
  },
  {
    path: '/users/search',
    component: UserSearchIndex,
    title: 'ユーザーを検索',
  },
  {
    path: '/users/search/:type(photo|area|body_shape|job|income|drink|cigarette|contact)',
    component: UserSearchType,
  },
  { path: '/users/search/new', component: UserSearchNew },
  { path: '/users/:uuid', component: UserShow },
];

export default ServerUser;
